const STATUS_CLASSNAME_MAP = {
  'added': 'success',
  'removed': 'danger',
  'changed': 'warning'
}

const STATUS_LABEL_MAP = {
  'added': 'New',
  'removed': 'Removed',
  'changed': 'Unsaved'
}

export default {
  props: {
    status: {
      type: [String, Boolean],
      default: false
    }
  },
  computed: {
    hasChanges () {
      return false
    },
    nestedStatus () {
      if (this.status) {
        return this.status
      } else if (this.hasChanges) {
        return 'changed'
      }
      return false
    },
    statusClassName () {
      return `badge-${STATUS_CLASSNAME_MAP[this.nestedStatus]}`
    },
    statusLabel () {
      return STATUS_LABEL_MAP[this.nestedStatus]
    }
  }
}
